import classNames from 'classnames';
import * as React from 'react';
import type { PortfolioTheme } from '../PortfolioItem/types';
import { useTheme } from '~/Features/Layouts/Theme/Context/ThemeContextProvider';
import { ButtonSize } from '~/Partials/Button/ButtonSize.csharp';
import { ButtonTier } from '~/Partials/Button/ButtonTier.csharp';
import { Link } from '~/Partials/Link/Link';
import { LinkType } from '~/Partials/Link/LinkType.csharp';
import type { LinkViewModel } from '~/Partials/Link/LinkViewModel.csharp';
import { SvgIcon } from '~/Partials/SvgIcon/SvgIcon';
import styles from './PortfolioCallToAction.module.css';

export interface PortfolioCallToActionProps {
    callToActionLink: LinkViewModel;
    description?: string;
    theme?: PortfolioTheme;
}

export const PortfolioCallToAction: React.FC<PortfolioCallToActionProps> = props => {
    const contextualTheme = useTheme();
    const { description, callToActionLink, theme = contextualTheme } = props;

    const { withRoundedCorners } = theme;

    return (
        <div className={classNames(styles.PortfolioCallToAction, withRoundedCorners && styles['Variant--rounded'])}>
            {description && <div className={styles.Description}>{description}</div>}
            <Link
                {...callToActionLink}
                className={styles.Link}
                type={LinkType.Button}
                buttonTier={ButtonTier.Primary}
                buttonSize={ButtonSize.ResponsiveFromSmallToMedium}
                theme={theme}
                showIsExternal={false}
            >
                <span>{callToActionLink.label}</span>
                <SvgIcon iconName="arrow-right" />
            </Link>
        </div>
    );
};
